import { Component } from '@angular/core';
import { Child } from '../../models/child';
import { Globals } from '../../services/globals';
import { LocalStorageService } from '../../services/local-storage.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './choose-children.html',
  styleUrls: ['./choose-children.scss'],
})

export class ChooseChildrenPage {

  /**
   * 아동 정보
   */
  private childrenData: Child[];

  /**
   * 성별에 따른 스타일
   */
  private styleList: Object = {};

  /**
   * Local Storage
   */
  private local: LocalStorageService = new LocalStorageService();

  /**
   * 아동 수 3명 이상인가
   */
  isOverCouple: boolean;

  /**
   * 아동 수 3명인가
   */
  isTriple: boolean;

  /**
   * @constructor
   */
  constructor(
    private g: Globals,
    private router: Router) {
    this.childrenData = g.children;
    this.isOverCouple = this.childrenData.length > 2;
    this.isTriple = this.childrenData.length === 3;

    let cntBoy: number = 0;
    let cntGirl: number = 0;

    this.childrenData.forEach((child) => {
      if (child.isMale) {
        cntBoy = cntBoy + 1;
        if (cntBoy > 3) {
          cntBoy = 1;
        }
        this.styleList[child.num] = 'boy' + (cntBoy === 1 ? '' : cntBoy);
      } else {
        cntGirl = cntGirl + 1;
        if (cntGirl > 3) {
          cntGirl = 1;
        }
        this.styleList[child.num] = 'girl' + (cntGirl === 1 ? '' : cntGirl);
      }
    });
  }

  /**
   * 아동 선택 후 메인 페이지로 이동
   */
  chooseChild(child: Child) {
    // 자동 로그인을 위해 식별번호 저장
    this.local.setChildNum(child.num.toString());
    // 선택한 아동 정보 공유 정보로 저장
    this.g.child = child;
    this.router.navigate(['/home']);
  }

  /**
   * 아동 성별에 따라 스타일 지정
   */
  getStyleChildrenList(child: Child): string {
    return this.styleList[child.num];
  }
}
